export const CustomerIntent = {
  PERSONAL: 'PERSONAL',
  BUSINESS: 'BUSINESS',
} as const
